var map = {
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"./cards/cards.module": [
		"./src/app/cards/cards.module.ts",
		"common",
		"cards.module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./epin/epin.module": [
		"./src/app/epin/epin.module.ts",
		"common",
		"epin.module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"./pinmailer/pinmailer.module": [
		"./src/app/pinmailer/pinmailer.module.ts",
		"common",
		"pinmailer.module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"./stock/stock.module": [
		"./src/app/stock/stock.module.ts",
		"common",
		"stock.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main